import { useMemo } from 'react';
import type { Platform } from '../types';
import { RATIO_OPTIONS_BY_PLATFORM } from '../constants';

export const useAspectRatioOptions = (platform: Platform) => {
  return useMemo(() => RATIO_OPTIONS_BY_PLATFORM[platform], [platform]);
};
